export default "__VITE_ASSET__Bty6FPQp__"